import React, { memo } from 'react';
import classnames from 'classnames';
import { Card } from 'tea-component';
import './index.scss';

interface IPlaceholderCardProps extends IBaseProps {
  title?: string;
  titleIcon?: React.ReactElement;
  placeholder?: string;
}

const PlaceholderCard: React.FC<IPlaceholderCardProps> = (props) => {
  const {
    title,
    titleIcon,
    placeholder = 'Coming Soon',
    locale = 'en',
    style,
    className,
    ...remains
  } = props;

  return (
    <>
      <Card
        {...remains}
        style={style}
        className={classnames(
          'gp-common-placeholder-card dbg-card-slot',
          className,
        )}
      >
        <Card.Body
          title={
            <div className="gp-common-placeholder-card-title-container">
              {titleIcon && (
                <div className="gp-common-placeholder-card-title-icon-container">
                  {titleIcon}
                </div>
              )}
              <span>{title}</span>
            </div>
          }
        >
          <span className="gp-common-placeholder-text">{placeholder}</span>
        </Card.Body>
      </Card>
    </>
  );
};

export default memo(PlaceholderCard);
